import { irisApi } from './iris';
export * from './iris';
export const irisEndpoints = { ...irisApi.endpoints };
